import { Component, OnInit } from '@angular/core';
import {IDialogView} from "@shared/components/ok-cancel-dialog/ok-cancel-dialog.component";
import {DialogModel} from "@shared/models/dialog.model";
import {FieldDefinition} from "@shared/models/field-definition";

@Component({
    standalone: false,
    selector: 'particle-confirm-transmission-dialog',
  templateUrl: './confirm-transmission-dialog.component.html',
  styleUrls: ['./confirm-transmission-dialog.component.scss']
})
export class ConfirmTransmissionDialogComponent implements OnInit, IDialogView {
  data: DialogModel;
  hasCustomFields: boolean;
  fieldDefinitions: FieldDefinition[];
  item: any;
  isAgree: boolean;
  isAllMandatoryFieldsOk: boolean;
  constructor() { }

  ngOnInit() {
    this.hasCustomFields = false;
    this.isAgree = false;
    this.isAllMandatoryFieldsOk = true;
    this.data.isDisabledOkButton = true;
    if (this.data && this.data.input && this.data.input.data && this.data.input.data.customFields) {
      if (this.data.input.data.customFields.length > 0) {
        this.hasCustomFields = true;
        this.fieldDefinitions = this.data.input.data.customFields;
        this.fieldDefinitions.forEach(field => {
          if (field.isMandatory) {
            this.isAllMandatoryFieldsOk = false;
          }
        });
        this.item = {
          cells: {}
        };
      }
    }
  }
  onCheck(event) {
    if (event.checked) {
      this.isAgree = true;
    } else {
      this.isAgree = false;
    }
    this.updateOkButton();
  }
  updateOkButton() {
    if (this.isAgree && this.isAllMandatoryFieldsOk) {
      this.data.isDisabledOkButton = false;
    } else {
      this.data.isDisabledOkButton = true;
    }
  }
  onOkClicked(): boolean {
    this.data.input['TransmissionData'] = this.item;
    return true;
  }
  onValueChanged(event) {
    let allFieldsOk = true;
    this.fieldDefinitions.forEach(field => {
      if (field.isMandatory) {
        if (!event.item || !event.item.cells || !event.item.cells[field.key] || !event.item.cells[field.key].value || event.item.cells[field.key].value.length === 0) {
          allFieldsOk = false;
        }
      }
    });
    this.isAllMandatoryFieldsOk = allFieldsOk;
    this.updateOkButton();
    console.log('Value Changed::', event);
  }
}
